import api from './api';

export const tutorService = {
  // Profile APIs
  getProfile: async () => {
    const response = await api.get('/tutor/profile');
    return response.data;
  },

  saveProfile: async (data) => {
    const response = await api.post('/tutor/profile', data);
    return response.data;
  },

  getStatus: async () => {
    const response = await api.get('/tutor/status');
    return response.data;
  },

  // Document APIs
  getDocuments: async () => {
    const response = await api.get('/tutor/documents');
    return response.data;
  },

  uploadDocument: async (formData) => {
    const response = await api.post('/tutor/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteDocument: async (id) => {
    const response = await api.delete(`/tutor/documents/${id}`);
    return response.data;
  },

  // Skill Test APIs
  getTestQuestions: async (subjectClasses) => {
    const response = await api.post('/tutor/skill-test/questions', {
      subject_classes: subjectClasses,
    });
    return response.data;
  },

  submitTest: async (testId, answers) => {
    const response = await api.post('/tutor/skill-test/submit', {
      test_id: testId,
      answers,
    });
    return response.data;
  },

  getTestResult: async (testId) => {
    const response = await api.get(`/tutor/skill-test/result/${testId}`);
    return response.data;
  },

  // Activity Skills APIs
  getActivitySkills: async () => {
    const response = await api.get('/activity-skills');
    return response.data;
  },

  // Master Data APIs (for dynamic board-class-subject)
  getBoards: async () => {
    const response = await api.get('/boards');
    return response.data;
  },

  getClasses: async () => {
    const response = await api.get('/classes');
    return response.data;
  },

  getSubjects: async (type = 'academic') => {
    const response = await api.get(`/subjects?type=${type}`);
    return response.data;
  },

  getClassSubjects: async (classId) => {
    const response = await api.get(`/classes/${classId}/subjects`);
    return response.data;
  },

  // Video Upload APIs
  uploadDemoVideo: async (formData) => {
    const response = await api.post('/tutor/upload-demo-video', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteDemoVideo: async (videoPath) => {
    const response = await api.delete('/tutor/delete-demo-video', {
      data: { video_path: videoPath }
    });
    return response.data;
  },

  getIdCard: async () => {
    const response = await api.get('/tutor/id-card');
    return response.data;
  },

  regenerateQrCode: async () => {
    const response = await api.post('/tutor/id-card/regenerate');
    return response.data;
  },

  getIdCardStats: async () => {
    const response = await api.get('/tutor/id-card/stats');
    return response.data;
  },
};
